import { InfoCard } from "@ui/components/InfoCard";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import { LandingContainer } from "./LandingContainer";

export class CsokPlusComponent extends React.PureComponent {
	public render(): ReactNode {
		return (
			<LandingContainer>
				<InfoCard variant="retail" title="Jobb tudni" className="text-white">
					<Card.Body>
						<a href="/mediatar/cikk/elso-lakasnal-nem-lesz-eleg-csok-plusznal-a-10-onero/?link_type=landing-link">
							Akár 10% önerő is elegendő lehet,
						</a>{" "}
						ha első lakás vásárlása előtt állsz! A 2024. januárjától érvényes MNB rendelet alapján a
						hitelösszeg tehát az ingatlan értékének akár 90%-a is lehet, ha megfelelsz a feltételeknek:
						<ul>
							<li>igényléskor nem töltheted be a 41. életéved (adóstársra ez szintén érvényes)</li>
							<li>
								adósként és adóstársként sem rendelkezhettél korábban ingatlanban 50%-ot elérő tulajdoni
								hányaddal, kivéve olyan lakás, melyet jogszabály alapján haszonélvezeti jog terhelt.
							</li>
						</ul>
					</Card.Body>
				</InfoCard>
			</LandingContainer>
		);
	}
}
